import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { debounceTime, Subject, Subscription } from 'rxjs';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { SeoService } from 'src/app/seo/seo.service';
import { DarkmodeService } from 'src/app/services/darkmode.service';
import { WebsiteAuditService } from '../website-audit.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { InfoModalComponent } from 'src/app/seo/modals/info-modal/info-modal.component';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';

@Component({
  selector: 'app-seo',
  templateUrl: './seo.component.html',
  styleUrls: [
    '../../seo/ai-analysis/ai-analysis.component.css',
    '../../seo/projects-page/projects-page.component.css',
    '../../diagnostics/overall/overall.component.css',
    '../../seo/ai-analysis/tasks-simplified/tasks-simplified.component.css',
    './seo.component.css',
  ],
})
export class SeoComponent implements OnInit, OnDestroy {
  constructor(
    private seoService: SeoService,
    private darkModeService: DarkmodeService,
    private dialog: MatDialog,
    private localStorageService: LocalStorageService,
    private notificationService: NotificationService,
    private websiteAuditService: WebsiteAuditService,
    private router: Router,
  ) {}
  analysisSub: Subscription = new Subscription();

  showDesignV2: boolean = true;

  infoDialogRef: MatDialogRef<InfoModalComponent>;

  show_ai_score_column: boolean = false;
  numberOfShownElement: number = 3;

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  // pagination
  dataSource = new MatTableDataSource<any>();
  pageIndex: number = 0;
  pageSize: number = 10;
  pageSizeOptions: number[] = [5, 10, 25, 100];

  contentFrontPage: boolean = true;
  editorData: any;

  aiAnalysisDataLoading: any = false;
  firstLoad: any = true;
  showDummyData = false;

  onPageFactors: object = {};
  backlinksFactors: object = {};
  technicalFactors: object = {};
  relevancies: any = {};
  backlink_relevancies: any = {};
  mainObject: any = {};
  descriptions: object = {};

  internalTotalCount: any;
  backlinkTotalCount: any;

  competitorsData: any = [];
  selectedCompetitorData: any = {};
  backLinkselectedVariable: any = '';

  selectedTabIndex = 0;
  activeTab: string = 'Overview';
  previewAnalysis = false;
  animateSlideClass = false;
  rate: any = '-';
  listOfVariables: any = [];
  listOfKeywords: any = [];
  renamed_variables: any;
  rename_variables_positive: any;
  measurementIsLoading: any = true;
  listOfCategories: any;
  rankingImpactDirection: any = '1';
  backlinkRelevanceTableActive: any = false;

  barChartOutputData: any = {};
  overviewBarChartOutputData: any = {};
  cardData: any;
  selectedCard = 'All KPIs';

  formatted_barchartInputDataPageIndex: number = 1;
  formatted_barchartInputData_items_per_page: number = 4;
  formatted_barchartInputData: any = [];
  all_formatted_barchartInputData: any = [];

  renamed_variables_2: any;

  showCustomChart: boolean = false;
  sepDescription: string = 'Description of content relevance is shown here';

  currentIndex: number = 0;
  currentStatus: string = 'Starting...';
  currentProgress: number = 0;
  showLoader: boolean = false;

  projectChanger: Subscription;

  horizontalSingleSelectOptions: any = [
    {
      value: 'you',
      viewValue: 'You',
      selected: true,
      format: 'short',
    },
    {
      value: 'competitor',
      viewValue: 'Competitor',
      selected: false,
    },
  ];
  horizontalSingleOptionStyles = {
    width: innerWidth < 1441 ? '35px' : '40px',
    transform: '0px',
  };
  selectedFilterButton: any = 'you';
  renamedVariables: any = {};
  renamedVariables_positive: any = {};
  isFirstExecution: boolean = true;

  isDarkMode: boolean = false;

  modelCardsDataDescriptionMAP: any = [
    {
      max: 30,
      description:
        'Barely showing up — performance is very limited and visibility is low',
    },
    {
      max: 60,
      description:
        'Starting to show up more often — performance is improving but still inconsistent',
    },
    {
      max: 80,
      description:
        'Showing up regularly — performance is strong and visibility is reliable',
    },
    {
      max: 100,
      description:
        'Always showing up — performance is excellent and visibility is very high',
    },
  ];

  modelCardsData: any = [
    {
      name: 'SERP Performance',
      description:
        'Legacy search methods declining in effectiveness compared to AI-driven approaches',
      icon: {
        src: '../../../assets/img/icons/google-logo.svg',
        alt: 'SERP Performance',
        hasDarkMode: false,
      },
      selected: false,
      value: 'view_all',
      score: 0,
      backend_key: 'traditional_search',
    },
    // {
    //   name: 'ChatGPT Performance',
    //   description:
    //     "OpenAI's AI model showing steady improvement in search relevance and accuracy",
    //   icon: {
    //     src: this.isDarkMode
    //       ? '../../../assets/img/icons/openai-logo_light.svg'
    //       : '../../../assets/img/icons/openai-logo.svg',
    //     alt: 'ChatGPT Performance',
    //     hasDarkMode: true,
    //   },
    //   selected: false,
    //   value: 'chatgpt',
    //   score: 0,
    //   backend_key: 'gpt_performance',
    // },
    // {
    //   name: 'Gemini Performance',
    //   description:
    //     "Google's AI model showing steady improvement in search relevance and accuracy",
    //   icon: {
    //     src: '../../../assets/img/icons/gemini-logo.svg',
    //     alt: 'Gemini Performance',
    //     hasDarkMode: false,
    //   },
    //   selected: false,
    //   value: 'gemini',
    //   score: 0,
    //   backend_key: 'gemini_performance',
    // },
  ];

  progressChartStyleObj: any = {
    strokeWidth: 4,
    width: window.innerWidth < 1441 ? 70 : 80,
    height: window.innerWidth < 1441 ? 70 : 80,
    valueFontSize: window.innerWidth < 1441 ? '16px' : '20px',
    titleBottom: true,
    unit: '%',
  };

  contentStrengthOverviewDataDescriptionMAP: any = [
    {
      max: 49,
      description: 'Needs stronger content',
    },
    {
      max: 89,
      description: 'Decent content, room to grow',
    },
    {
      max: 100,
      description: 'Strong content driving engagement',
    },
  ];
  linkStrengthOverviewDataDescriptionMAP: any = [
    {
      max: 49,
      description: 'Weak backlink profile',
    },
    {
      max: 89,
      description: 'Some backlinks, could improve',
    },
    {
      max: 100,
      description: 'Solid backlink authority',
    },
  ];
  siteStrengthOverviewDataDescriptionMAP: any = [
    {
      max: 49,
      description: 'Technical issues affecting site',
    },
    {
      max: 89,
      description: 'Acceptable performance, minor fixes needed',
    },
    {
      max: 100,
      description: 'Excellent technical performance',
    },
  ];

  siteStrengthOverviewData: any = [
    {
      value: 0,
      title: 'Content Strength',
      description: 'High-quality content driving engagement',
      style: this.progressChartStyleObj,
      backend_key: 'content_strength',
      category: 'Content Relevance',
      getDescription: () => {
        return this.contentStrengthOverviewDataDescriptionMAP.find(
          (item: any) => item.max >= this.siteStrengthOverviewData[0].value,
        )?.description;
      },
    },
    {
      value: 0,
      title: 'Link Strength',
      description: 'Backlink profile needs improvement',
      style: this.progressChartStyleObj,
      backend_key: 'link_health',
      category: 'Backlink Relevance',
      getDescription: () => {
        return this.linkStrengthOverviewDataDescriptionMAP.find(
          (item: any) => item.max >= this.siteStrengthOverviewData[1].value,
        )?.description;
      },
    },
    {
      value: 0,
      title: 'Site Health',
      description: 'Excellent technical performance',
      style: this.progressChartStyleObj,
      backend_key: 'site_health',
      category: 'Technical',
      getDescription: () => {
        return this.siteStrengthOverviewDataDescriptionMAP.find(
          (item: any) => item.max >= this.siteStrengthOverviewData[2].value,
        )?.description;
      },
    },
  ];

  horizontalOptionsCategory = [
    {
      value: 'Content Relevance',
      viewValue: 'Content',
      selected: true,
    },
    {
      value: 'Backlink Relevance',
      viewValue: 'Link',
      selected: true,
    },
    {
      value: 'Technical',
      viewValue: 'Site Health',
      selected: false,
    },
  ];
  horizontalOptionStylesCategory = {
    width: '80px',
    transform: '0px',
  };

  quick_wins: any = {};

  cardsData: any = [
    {
      name: "All KPI's",
      value: 0,
      selected: false,
      competitor: 0,
    },
  ];

  loaderFactors: any = [
    {
      text: 'On-Page Factors',
      name: 'onPageFactors',
      value: 0,
      disabled: false,
    },
    {
      text: 'Technical Factors',
      name: 'technicalFactors',
      value: 0,
      disabled: false,
    },
    // {
    //   text: "Social Factors",
    //   name: "socialFactors",
    //   value: 0,
    //   disabled: false,
    // },
    {
      text: 'RAW - Backlinks',
      name: 'rawBacklinks',
      value: 0,
      disabled: false,
    },
    {
      text: 'Backlinks Factors',
      name: 'backlinksFactors',
      value: 0,
      disabled: false,
    },
  ];
  activeFilter: any = 'showAll';
  keywordData: any;
  filters: any = [
    {
      text: 'Show All',
      value: 'showAll',
      active: true,
    },
    {
      text: 'Content Relevance',
      value: 'contentRelevance',
      active: false,
    },
    {
      text: 'Backlink Profile',
      value: 'backlinkProfile',
      active: false,
    },
    {
      text: 'Backlink Relevance',
      value: 'backlinkRelevances',
      active: false,
    },
    {
      text: 'Internal Linking',
      value: 'internalLinking',
      active: false,
    },
    {
      text: 'Technical',
      value: 'technical',
      active: false,
    },
  ];

  isAnalyzing: any = false;
  rankings: any = [];
  tableHeaderTitles: any = [];
  clickedFactor: any = null;
  showNameClickedFactor = '';

  toogleCompetitor: boolean = false;
  competitorURL: string = '';

  barloaderv2_percentage: any = 0;
  showBarloaderv2: boolean = false;

  headlinesTexts: any = [
    {
      text: 'Getting Backlinks',
      event: 'get-backlinks',
      active: true,
      hide: false,
    },

    {
      text: 'Getting Internal Links',
      event: 'get-internal-links',
      active: false,
      hide: false,
    },
    {
      text: 'Getting Page Rank and Embeddings',
      event: 'get-page-rank-and-embeddings',
      active: false,
      hide: false,
    },
    {
      text: 'Getting Link Juice',
      event: 'get-link-juice',
      active: false,
      hide: false,
    },
    {
      text: 'Getting All Relevances',
      event: 'get-all-relevances',
      active: false,
      hide: false,
    },
    {
      text: 'Getting Model Results',
      event: 'get-model-results',
      active: false,
      hide: false,
    },
    {
      text: 'Getting Backlink Relevances',
      event: 'get-backlink-relevances',
      active: false,
      hide: false,
    },
    { text: 'Done!', active: false, hide: false },
  ];

  socketLoaders: any[] = [
    { name: 'Getting Backlinks', event: 'get-backlinks', percentage: 0 },
    {
      name: 'Getting Internal Links',
      event: 'get-internal-links',
      percentage: 0,
    },
    {
      name: 'Getting Page Rank and Embeddings',
      event: 'get-page-rank-and-embeddings',
      percentage: 0,
    },
    { name: 'Getting Link Juice', event: 'get-link-juice', percentage: 0 },
    {
      name: 'Getting All Relevances',
      event: 'get-all-relevances',
      percentage: 0,
    },
    {
      name: 'Getting Model Results',
      event: 'get-model-results',
      percentage: 0,
    },
    {
      name: 'Getting Backlink Relevances',
      event: 'get-backlink-relevances',
      percentage: 0,
    },
  ];
  socket_object: any = {};

  suggestedUrls: any = [];
  suggestedUrlsFiltered: any = [];

  addKeywordFromModal: any = null;
  addKeywordFromTable: any = null;

  showRankingLineChart: boolean = false;
  hideLineChartOnly: boolean = false;

  showPageContent: boolean = false;

  internalLinkingDataTable: any = [];

  showBacklinkOnlyTable: boolean = false;
  showInternalLinkOnlyTable: boolean = false;
  backlinkOnlyTableData: any = [];
  tableVarianleOne: string = '';
  tableVarianleTwo: string = '';
  domainOptions: any[] = [];
  selectDomainOption: string = 'Show All';

  analysisDataSession: any = {};

  allProjects: any = [];
  selectedProject: any = {};
  selectedProjectURL: any = '';
  selectedProjectDomain: any = '';

  allKeywords: any = [];

  rankingError: any = false;

  horizontalOptions = [
    { value: 'ai_analysis', viewValue: 'Summary', selected: true },
    {
      value: 'competitor_comparison',
      viewValue: 'Competitor Comparison',
      selected: true,
    },
  ];
  horizontalOptionStyles = {
    width: window.innerWidth < 1441 ? '35px' : '85px',
    transform: '0px',
  };

  currentAnalysisID: string;

  saveIndex: any;

  units: any = {};

  selectedObject: any;

  correct_values: any = {};
  comp_combined_values: any = {};

  loadingProjeect: boolean = false;

  private selectedValueSub: Subscription;

  redirectFromContent: boolean = false;

  competitorExists: boolean = false;
  stopScrollBehavior: boolean = false;

  clickedIssue: any;

  selected_search_option: string = 'Keyword';
  selected_search_input: string = '';
  selected_search_input_autofill: string = '';
  selected_search_suggested_texts: any = [];
  private keyword_inputSubject = new Subject<string>();

  keyword_input_placehodler: string = '';
  url_input_placehodler: string = '';

  showViewAllActiveProjectButton: boolean = false;
  isViewAllActiveProject: boolean = false;

  uniqueProjects: any = [];

  selectedModel: any = 'view_all';
  selectedModelObj: any = {
    name: 'Google',
    value: 'view_all',
    icon: '../../../assets/img/icons/google-logo.svg',
  };

  models: any = [
    {
      name: 'Google',
      value: 'view_all',
      icon: '../../../assets/img/icons/google-logo.svg',
    },
    {
      name: 'ChatGPT',
      value: 'chatgpt',
      icon: '../../../assets/img/icons/openai-logo.svg',
    },
    {
      name: 'Gemini',
      value: 'gemini',
      icon: '../../../assets/img/icons/gemini-logo.svg',
    },
  ];

  ngOnInit() {
    function getDomainFromUrl(url: string): string | null {
      try {
        const normalized = url.startsWith('http') ? url : `https://${url}`;

        const { hostname } = new URL(normalized);
        return hostname.replace(/^www\./, '');
      } catch {
        return null;
      }
    }

    // Listen for input updates for keyword suggestions
    this.keyword_inputSubject.pipe(debounceTime(300)).subscribe((value) => {
      if (value !== this.selected_search_input) {
        this.selected_search_input = value;
        this.getSearchSuggestedTexts();
      }
    });

    this.analysisSub.add(
      this.websiteAuditService
        .getSelectedAuditTask()
        .subscribe((selectedTast: any) => {
          if (selectedTast) {
            if (this.selectedProject?.taskId == selectedTast?.taskId) {
              return;
            }

            selectedTast['domain'] = getDomainFromUrl(selectedTast?.['url']);

            this.loadingProjeect = true;

            this.selectedProjectURL = selectedTast?.['url'];
            this.selectedProjectDomain = selectedTast?.['domain'];
            this.selectedProject = selectedTast;

            this.cardsData = [
              {
                name: "All KPI's",
                name_translate: 'all_KPI_s',
                value: 0,
                selected: true,
                competitor: 0,
                main_variable_description: `main_variable_description_translate`,
              },
              {
                name: 'Content Relevance',
                name_translate: 'content_relevance',
                value: 0,
                selected: false,
                competitor: 0,
              },
              {
                name: 'Backlink Relevance',
                name_translate: 'backlink_relevance',
                value: 0,
                selected: false,
                competitor: 0,
              },
              {
                name: 'Backlink Profile',
                name_translate: 'backlink_profile',
                value: 0,
                selected: false,
                competitor: 0,
              },
              // {
              //   name: 'Internal Linking',
              //   name_translate: 'internal_linking',
              //   value: 0,
              //   selected: false,
              //   competitor: 0,
              // },
              {
                name: 'Technical',
                name_translate: 'technical',
                value: 0,
                selected: false,
                competitor: 0,
              },
            ];

            this.selected_search_input = '';
            this.selected_search_input_autofill = '';

            this.stopScrollBehavior = true;
            this.getKeywordsData(true);
            this.getSearchSuggestedTexts();

            this.selectedValueSub = this.seoService.selectedValue$.subscribe(
              (object) => {
                this.selectedFilterButton = 'you';
                this.horizontalSingleOptionStyles.width =
                  innerWidth < 1441 ? '35px' : '40px';
                this.horizontalSingleOptionStyles.transform = `translateX(${0}px)`;

                if (this.horizontalSingleSelectOptions[0]) {
                  this.horizontalSingleSelectOptions[0].selected = true;
                }

                if (object) {
                  this.selectedObject = object;
                  this.selectedLanguage = this.selectedObject.language;
                  this.selectedCompetitor = this.selectedObject.domain;

                  if (
                    this.selectedObject &&
                    this.selectedObject.category_summary
                  ) {
                    this.cardsData[0].competitor =
                      this.selectedObject.overall_mean;
                    for (
                      let i = 0;
                      i < this.barChartOutputData.category_summary?.length;
                      i++
                    ) {
                      const category =
                        this.barChartOutputData.category_summary[i];
                      const categoryValue =
                        this.selectedObject.category_summary[category.name] ||
                        0;

                      const matchingCard = this.cardsData.find(
                        (card: any) => card.name === category.name,
                      );

                      if (matchingCard) {
                        matchingCard.competitor = categoryValue;
                      }
                    }
                  }

                  if (this.showPageContent) {
                    this.getContentScoresBins();
                    this.getBacklinkScoresBins();
                  }
                }
              },
            );

            //     },
            //   }),
            // );
          }
        }),
    );

    const darkModeSub = this.darkModeService
      .getDarkMode()
      .subscribe((event) => {
        this.isDarkMode = this.localStorageService.get('darkMode') || false;

        this.modelCardsData.forEach((card: any) => {
          if (card.icon.hasDarkMode) {
            card.icon.src = this.isDarkMode
              ? card.icon.src.replace('logo.svg', 'logo_light.svg')
              : card.icon.src.replace('logo_light.svg', 'logo.svg');
          }
        });
      });
    this.analysisSub.add(darkModeSub);

    // window.onbeforeunload = () => this.ngOnDestroy();
  }
  ngOnDestroy() {
    if (this.selectedProject && this.selectedProject['_id']) {
      sessionStorage.setItem(
        'selectedProject',
        JSON.stringify(this.selectedProject),
      );
    }

    this.localStorageService.remove('activeTabAiAnalysis');

    this.analysisSub?.unsubscribe();
    this.projectChanger?.unsubscribe();
    this.selectedValueSub?.unsubscribe();
  }

  expandedRowIndex: number | null = null;
  expandedRowIndex2: number | null = null;

  toggleExpand(index: number): void {
    // this.isExpanded[index] = !this.isExpanded[index];
    this.expandedRowIndex = this.expandedRowIndex === index ? null : index;
  }
  toggleExpand2(index: number): void {
    // this.isExpanded[index] = !this.isExpanded[index];
    this.expandedRowIndex2 = this.expandedRowIndex2 === index ? null : index;
  }

  factorChange(data: any) {
    this.filters.filter((filter: any) => filter.active)[0].active = false;

    this.filters.filter((filter: any) => filter.text == data.name)[0].active =
      true;

    this.activeFilter = this.filters.filter(
      (filter: any) => filter.active,
    )[0].value;

    this.updateCustomChart();
  }

  saveValue(data: any) {
    this.seoService.setValue(data);
  }

  setAllValue(data: any) {
    this.seoService.setAllValue(data);
  }

  isCalled: boolean = true;

  keywordDataInsights: any;

  processUrl = (url: string) => {
    try {
      let cleanUrl = url;
      // Remove 'www.'
      if (cleanUrl.includes('www.')) {
        cleanUrl = cleanUrl.split('www.')[1];
      } else {
        cleanUrl = cleanUrl.split('//')[1];
      }

      // Remove query parameters and fragments
      if (cleanUrl.includes('?')) {
        cleanUrl = cleanUrl.split('?')[0];
      }
      if (cleanUrl.includes('#')) {
        cleanUrl = cleanUrl.split('#')[0];
      }
      if (cleanUrl.includes('&')) {
        cleanUrl = cleanUrl.split('&')[0];
      }

      // Ensure trailing slash
      if (!cleanUrl.endsWith('/')) {
        cleanUrl += '/';
      }

      // Process the path
      cleanUrl = cleanUrl.split('/').slice(1).join('/');

      if (cleanUrl === '') {
        cleanUrl = '/';
      }

      return cleanUrl;
    } catch (error) {
      return url;
    }
  };

  viewAllActiveProjects() {
    if (this.loadingProjeect) return;

    this.isViewAllActiveProject = !this.isViewAllActiveProject;
    this.stopScrollBehavior = true;
    this.loadingProjeect = true;
    this.getKeywordsData();
  }

  page_bins_loading: boolean = false;
  selectedLanguage: string = 'en';
  selectedCompetitor: string = '';
  page_bins: any = [];
  page_bins_lines: any = ['0', '1', '2', '3', '4'];
  ai_score_filter: any = [];
  gpt_score_filter: any = [];
  gemini_score_filter: any = [];
  chatgpt_bins: boolean = false;
  competitor_bins: boolean = false;
  gemini_bins: boolean = false;

  getContentScoresBins() {
    this.page_bins_loading = true;
    this.analysisSub.add(
      this.seoService
        .getContentScoresBins({
          domain: this.selectedProjectDomain,
          competitor_selected: this.selectedCompetitor,
          lang: this.selectedLanguage,
        })
        .subscribe({
          next: (response) => {
            this.constructPageBins(response);
          },
          error: (err) => {
            this.constructPageBins(null);
            console.log(err);
          },
        }),
    );
  }

  constructPageBins(data: any) {
    this.page_bins_loading = false;
    this.page_bins = [];
    this.page_bins_lines = [];

    if (!data || !data?.page_bins || Object.keys(data).length === 0) {
      return;
    }

    function generateScale(
      data: {
        your_value: number;
        competitor_value: number;
        chatgpt_value: number;
        gemini_value: number;
      }[],
    ): number[] {
      // Get the max value across all sources
      const maxValue = Math.max(
        ...data.flatMap((item) => [
          item.your_value || 0,
          item.competitor_value || 0,
          item.chatgpt_value || 0,
          item.gemini_value || 0,
        ]),
      );

      // Ensure minimum height for the chart
      const minMax = Math.max(maxValue, 4);

      // Round up to nearest multiple of 2 or 5 or 10 for prettier scales
      let stepBase = 1;
      if (minMax > 20) stepBase = 5;
      else if (minMax > 10) stepBase = 2;

      const topValue = Math.ceil((minMax * 1.1) / stepBase) * stepBase;
      const step = topValue / 4;

      return Array.from({ length: 5 }, (_, i) => Math.round(i * step));
    }

    let maxValue = 0;
    for (let key in data.page_bins) {
      let tmpObj: any = {
        your_value: data.page_bins[key],
        param: [parseInt(key.split('-')[0]), parseInt(key.split('-')[1])],
        name: key,
        selected: false,

        // competitor bins
        ...(this.selectedCompetitor &&
        this.selectedCompetitor != '' &&
        data?.competitor_bins?.[key] != undefined
          ? {
              competitor_value: data?.competitor_bins?.[key],
            }
          : {}),

        // chat gpt bins
        ...(data?.chatgpt_page_bins?.[key] != undefined && {
          chatgpt_value: data?.chatgpt_page_bins?.[key],
        }),

        // gemini bins
        ...(data?.gemini_page_bins?.[key] != undefined && {
          gemini_value: data?.gemini_page_bins?.[key],
        }),
      };

      this.page_bins.push(tmpObj);

      if (data.page_bins[key] > maxValue) {
        maxValue = data.page_bins[key];
      }
      if (data.competitor_bins?.[key] > maxValue) {
        maxValue = data.competitor_bins?.[key];
      }
      if (data.chatgpt_page_bins?.[key] > maxValue) {
        maxValue = data.chatgpt_page_bins?.[key];
      }
      if (data.gemini_page_bins?.[key] > maxValue) {
        maxValue = data.gemini_page_bins?.[key];
      }
    }

    this.page_bins_lines = generateScale(this.page_bins);
    const scaleFactor = Math.max(
      this.page_bins_lines[this.page_bins_lines.length - 1] || 1,
      maxValue,
    );

    this.page_bins = this.page_bins.map((item: any) => {
      item['your_percentage'] = parseFloat(
        ((item.your_value / scaleFactor) * 100).toFixed(2),
      );
      if (this.selectedCompetitor && this.selectedCompetitor != '') {
        item['competitor_percentage'] = parseFloat(
          ((item.competitor_value / scaleFactor) * 100).toFixed(2),
        );
      }
      if (item['chatgpt_value'] != undefined) {
        item['chatgpt_percentage'] = parseFloat(
          ((item.chatgpt_value / scaleFactor) * 100).toFixed(2),
        );
      }
      if (item['gemini_value'] != undefined) {
        item['gemini_percentage'] = parseFloat(
          ((item.gemini_value / scaleFactor) * 100).toFixed(2),
        );
      }
      return item;
    });

    if (this.page_bins?.[0]?.['competitor_value'] != undefined) {
      this.competitor_bins = true;
      this.chatgpt_bins = false;
    } else if (this.page_bins?.[0]?.['chatgpt_value'] != undefined) {
      this.competitor_bins = false;
      this.chatgpt_bins = true;
    } else {
      this.chatgpt_bins = false;
      this.competitor_bins = false;
    }

    this.gemini_bins = false;
    if (this.page_bins?.[0]?.['gemini_value'] != undefined) {
      this.gemini_bins = true;
    }

    if (this.page_bins_lines?.[4] == 0) {
      this.page_bins_lines = [0, 1, 2, 3, 4];
    }

    this.page_bins.forEach((item: any) => {
      item['horizontal_percentage'] =
        this.selectedModel == 'view_all'
          ? item['your_percentage']
          : item[`${this.selectedModel}_percentage`];

      item['horizontal_value'] =
        this.selectedModel == 'view_all'
          ? item['your_value']
          : item[`${this.selectedModel}_value`];
    });
  }

  getBacklinkScoresBins() {
    this.analysisSub.add(
      this.seoService
        .getBacklinkScoresBins({
          domain: this.selectedProjectDomain,
        })
        .subscribe({
          next: (response) => {
            this.constructBacklinkScoresBins(response);
          },
          error: (err) => {
            this.constructBacklinkScoresBins(null);
            this.notificationService.info('Something went wrong!');
          },
        }),
    );
  }

  backlink_bins: any = [];
  constructBacklinkScoresBins(data: any) {
    this.backlink_bins = [];

    if (!data || !data?.bins || Object.keys(data).length === 0) {
      return;
    }

    let maxValue = 0;
    for (let key in data.bins) {
      let tmpObj: any = {
        value: data.bins[key],
        param: [parseInt(key.split('-')[0]), parseInt(key.split('-')[1])],
        name: key,
      };

      this.backlink_bins.push(tmpObj);

      if (data.bins[key] > maxValue) {
        maxValue = data.bins[key];
      }
    }

    let stepBase = 1;
    if (maxValue > 20) stepBase = 5;
    else if (maxValue > 10) stepBase = 2;
    const topValue = Math.ceil((maxValue * 1.1) / stepBase) * stepBase;

    this.backlink_bins = this.backlink_bins.map((item: any) => {
      item['percentage'] = parseFloat(
        ((item.value / topValue) * 100).toFixed(2),
      );
      return item;
    });
  }

  quick_wins_array: any = [];
  content_score_fixes: any = [];
  backlink_score_fixes: any = [];

  selected_category: any = 'Content Relevance';
  overall_fixes_data: any = [];

  constructFixes(data: any) {
    this.overall_fixes_data = data;
    this.content_score_fixes = [];
    this.backlink_score_fixes = [];
    this.quick_wins_array = [];

    data.forEach((item: any) => {
      if (
        this.quick_wins[item.name] &&
        item.tmp_category == this.selected_category
      ) {
        this.quick_wins_array.push(this.quick_wins[item.name]);
      }

      if (item.tmp_category == this.selected_category) {
        this.content_score_fixes.push(item);
      } else if (item.tmp_category == 'Backlink Relevance') {
        this.backlink_score_fixes.push(item);
      }
    });
  }

  clickCategory(category: string) {
    this.selected_category = category;
    this.constructFixes(this.overall_fixes_data);
  }

  onToggleChangeCategory(event: any, item: any, customStyles: any) {
    let domOption = event.target.closest('.custom_horizontal_option_select');
    customStyles.width = domOption.clientWidth + 'px';
    customStyles.transform = `translateX(${domOption.offsetLeft}px)`;

    for (let i = 0; i < this.horizontalOptionsCategory.length; i++) {
      this.horizontalOptionsCategory[i].selected = false;
    }

    item.selected = true;
    this.selected_category = item.value;
    this.constructFixes(this.overall_fixes_data);
  }

  content_score_fixes_direction: any = 1;
  backlink_score_fixes_direction: any = 1;
  active_content_score_fixes_key: any = '';
  active_backlink_score_fixes_key: any = '';

  sortQuickFixesFunction(key: string, arrayName: any) {
    if (arrayName == 'content_score_fixes') {
      if (key == this.active_content_score_fixes_key) {
        this.content_score_fixes_direction =
          this.content_score_fixes_direction === 1 ? -1 : 1;
      } else {
        this.active_content_score_fixes_key = key;
        this.content_score_fixes_direction = 1;
      }

      this.content_score_fixes = this.content_score_fixes.sort(
        (a: any, b: any) => {
          if (this.content_score_fixes_direction == 1) {
            return parseFloat(b[key]) - parseFloat(a[key]);
          } else {
            return parseFloat(a[key]) - parseFloat(b[key]);
          }
        },
      );
    } else if (arrayName == 'backlink_score_fixes') {
      if (key == this.active_backlink_score_fixes_key) {
        this.backlink_score_fixes_direction =
          this.backlink_score_fixes_direction === 1 ? -1 : 1;
      } else {
        this.active_backlink_score_fixes_key = key;
        this.backlink_score_fixes_direction = -1;
      }

      this.backlink_score_fixes = this.backlink_score_fixes.sort(
        (a: any, b: any) => {
          if (this.backlink_score_fixes_direction == 1) {
            return parseFloat(b[key]) - parseFloat(a[key]);
          } else {
            return parseFloat(a[key]) - parseFloat(b[key]);
          }
        },
      );
    }
  }

  getKeywordsData(projChanged = false) {
    this.showLoader = true;
    this.seoService
      .getKeywordsData({
        domain: this.selectedProject['domain'],

        ...(this.selected_search_input != ''
          ? this.selected_search_option == 'Keyword'
            ? { keyword: this.selected_search_input }
            : { url: this.processUrl(this.selected_search_input) }
          : {}),

        ...(this.isViewAllActiveProject ? { view_all_projects: true } : {}),

        ...(this.uniqueProjects.length > 0
          ? { uniqueProjects: this.uniqueProjects }
          : {}),

        ...(this.selectedModelObj.value != 'view_all'
          ? { model: this.selectedModelObj.value }
          : {}),
      })
      .subscribe(
        (res) => {
          this.uniqueProjects = res?.uniqueProjects ?? [];

          this.showViewAllActiveProjectButton =
            res?.has_multiple_projects ?? false;

          if (!res['competitor_data'] || res['competitor_data']?.length === 0) {
            this.competitorExists = false;
          } else {
            this.competitorExists = true;
          }
          this.keywordData = res;
          this.keywordDataInsights = this.keywordData;
          this.setAllValue(this.keywordData);

          if (res.competitor_data?.length > 0) {
            this.saveValue(this.keywordData.competitor_data);
          } else {
            this.saveValue({});
          }

          const formattedData = Object.keys(res.variables)
            .filter(
              (key) =>
                key != 'labels' &&
                key != 'domain' &&
                key != 'date' &&
                key != 'category_summary' &&
                key != 'general_obj',
            )
            .map((key) => ({
              variable: key,
              variables: Object.entries(res.variables[key]).map(
                ([name, value]) => ({
                  name,
                  value,
                  selected: false,
                }),
              ),
            }));

          this.renamed_variables = res.renamed_variables;
          this.renamed_variables_2 = res.new_object;
          this.rename_variables_positive = res.rename_variables_positive;

          this.barChartOutputData = {
            variable_labels: res.variable_labels,
            yourScore:
              res.technical_values_per_domain_for_range[
                this.keywordData.domain
              ],
            units: res.units,
            correct_values: res.correct_values,
            renamed_variables: res.renamed_variables,
            rename_variables_positive: res.rename_variables_positive,
            chartData: formattedData,
            date: res.date,
            domain: res.domain,
            labels: res.variables.labels,
            // variables: res.variables,
            variables: Object.keys(res.variables.category_summary).map(
              (key: any) => ({
                name: key,
                value: res.variables.category_summary[key],
              }),
            ),
            activeFilter: "All KPI's",
            top_selected: res.top_selected,
          };

          if (res.competitor_data?.length > 0) {
            this.barChartOutputData.category_summary = Object.keys(
              this.selectedObject?.category_summary,
            ).map((key: any) => ({
              name: key,
              value: this.selectedObject.category_summary[key],
            }));
            this.barChartOutputData.competitor_summary = Object.keys(
              this.selectedObject.category_summary,
            ).map((key: any) => ({
              name: key,
              value: this.selectedObject.category_summary[key],
            }));
            this.barChartOutputData.selectedCompetitor =
              this.selectedObject.domain;

            this.selectedCompetitor = this.selectedObject.domain;
          }

          this.cardsData[0].value = res.variables.overall_mean;
          if (res.competitor_data.length > 0) {
            this.cardsData[0].competitor = this.selectedObject.overall_mean;
          }

          this.renamedVariables = res.renamed_variables;
          this.renamedVariables_positive = res.rename_variables_positive;

          for (let i = 0; i < this.barChartOutputData.variables?.length; i++) {
            const cardData = this.cardsData.find((card: any) => {
              return card.name === this.barChartOutputData.variables[i].name;
            });
            if (cardData) {
              cardData['name'] = this.barChartOutputData.variables[i].name;
              cardData['value'] = this.barChartOutputData.variables[i].value;
              cardData['selected'] = false;
              cardData['competitor'] =
                this.barChartOutputData.competitor_summary?.[i]?.value || 0;
              cardData['main_variable_description'] =
                this.keywordData.main_variables_descriptions[
                  this.barChartOutputData.variables[i].name
                ];
            } else {
              this.cardsData.push({
                name: this.barChartOutputData.variables[i].name,
                value: this.barChartOutputData.variables[i].value,
                selected: false,
                competitor:
                  this.barChartOutputData.competitor_summary?.[i]?.value || 0,
                main_variable_description:
                  this.keywordData.main_variables_descriptions[
                    this.barChartOutputData.variables[i].name
                  ],
              });
            }
          }

          const order = [
            "All KPI's",
            'Content Relevance',
            'Backlink Relevance',
            'Backlink Profile',
            'Internal Linking',
            'Technical',
          ];

          this.cardsData.sort((a: any, b: any) => {
            return order.indexOf(a.name) - order.indexOf(b.name);
          });

          this.cardsData.forEach((card: any) => {
            if (card.name == 'Content Relevance' && this.redirectFromContent) {
              card['selected'] = true;
              this.cardClicked(card);
            } else {
              card['selected'] = false;
            }
          });

          // remove from display
          const hideFromDisplay = ['Internal Linking'];
          this.cardsData = this.cardsData.filter((card: any) => {
            return !hideFromDisplay.includes(card.name);
          });

          this.showPageContent = true;
          this.firstLoad = false;
          this.showLoader = false;
          this.showDummyData = false;

          this.loadingProjeect = false;

          const isAnyCardSelected = this.cardsData.find(
            (card: any) => card.selected,
          );
          if (!isAnyCardSelected && this.cardsData[0]) {
            this.cardsData[0].selected = true;
          }

          const generalObj = res?.variables?.general_obj;
          if (generalObj) {
            this.modelCardsData.forEach((card: any) => {
              card.score = generalObj[card.backend_key] || 0;
              card.description = this.modelCardsDataDescriptionMAP.find(
                (item: any) => item.max >= card.score,
              )?.description;
            });
            this.siteStrengthOverviewData.forEach((card: any) => {
              card.value = generalObj[card.backend_key] ?? 0;
            });
            this.siteStrengthOverviewData = this.siteStrengthOverviewData.map(
              (card: any) => ({
                ...card,
                description: card.getDescription(),
              }),
            );
          }

          this.quick_wins = res?.quick_wins || {};

          this.getContentScoresBins();
          this.getBacklinkScoresBins();
          this.constructBarchartData();
        },
        (error) => {
          this.showLoader = false;
          if (!this.firstLoad) {
            this.notificationService.info('Something went wrong!');
          } else {
            this.barChartOutputData = {};
            this.constructBarchartData();
            this.setAllValue({});
            this.saveValue({});
            this.competitorExists = false;
            this.firstLoad = false;
            this.showDummyData = true;
            this.showPageContent = true;
          }
          this.loadingProjeect = false;
        },
      );
  }
  getSearchSuggestedTexts() {
    const params = {
      domain: this.selectedProject['domain'],
      ...(this.selected_search_option == 'Keyword'
        ? { keyword: this.selected_search_input }
        : { url: this.processUrl(this.selected_search_input) }),

      ...(this.uniqueProjects.length > 0
        ? { uniqueProjects: this.uniqueProjects }
        : {}),

      ...(this.isViewAllActiveProject ? { view_all_projects: true } : {}),

      ...(this.selectedModelObj.value != 'view_all'
        ? { model: this.selectedModelObj.value }
        : {}),
    };

    this.analysisSub.add(
      this.seoService.getSearchSuggestedTexts(params).subscribe((res) => {
        if (this.selected_search_option == 'Keyword') {
          this.selected_search_suggested_texts = res?.topKeywords;
        } else {
          this.selected_search_suggested_texts = res?.topUrls;
        }

        if (res?.topKeywords) {
          this.keyword_input_placehodler = res?.topKeywords?.[0];
        }
        if (res?.topUrls) {
          this.url_input_placehodler = res?.topUrls?.[0];
        }
      }),
    );
  }
  clearUserSearch() {
    this.selected_search_input_autofill = '';
    this.selected_search_input = '';
    this.keyword_inputSubject.next('');

    this.loadingProjeect = true;
    this.stopScrollBehavior = true;
    this.getKeywordsData();
    this.getSearchSuggestedTexts();
  }
  filterKeywords(event: any) {
    const value = (event.target as HTMLInputElement).value;
    this.keyword_inputSubject.next(value);
  }
  searchClicked() {
    this.loadingProjeect = true;
    this.stopScrollBehavior = true;
    this.getKeywordsData();
  }

  cardName: string = `all_KPI_s`;
  cardDescription: string = `main_variable_description_translate`;

  cardClicked(card: any) {
    this.pageIndex = 0;
    this.selectedCard = card.name;
    this.cardsData.forEach((card: any) => (card.selected = false));
    card.selected = true;

    this.barChartOutputData.activeFilter = card.name;
    this.cardName = card.name_translate;
    this.cardDescription = card.main_variable_description;

    this.stopScrollBehavior = true;
    this.updateCustomChart(true);
  }

  formatValue(value: number) {
    if (value === 0) {
      return value.toFixed(0);
    } else if (Math.abs(value) >= 10) {
      return value.toFixed(0);
    } else if (Math.abs(value) < 1) {
      return value.toFixed(2);
    } else if (value % 1 !== 0) {
      return value.toFixed(2);
    } else {
      return value.toFixed(0);
    }
  }

  openInNewTab(url: string, item?: any): void {
    if (url) {
      if (url.includes(this.selectedProject.domain)) {
        window.open(url, '_blank');
      } else if (url.includes('http:') || url.includes('https:')) {
        window.open(url, '_blank');
      } else {
        const tmpUrl =
          this.selectedProject.url + (url.startsWith('/') ? url : '/' + url);
        window.open(tmpUrl, '_blank');
      }
    }
    // else if (item?.var1_link == '' && item?.var2_link != '') {
    //   window.open(item?.var2_link, '_blank');
    // }
  }

  constructKeywords(data: any) {
    if (!data || !data['keywords']) {
      this.allKeywords = [];
      return;
    }

    this.allKeywords = data['keywords'];

    this.suggestedUrls = [];
    this.suggestedUrlsFiltered = [];

    let projectUrl = this.selectedProject?.['url']
      ?.replace('http://', '')
      .replace('https://', '');

    let url = '';
    for (let i = 0; i < data['keywords'].length; i++) {
      if (
        data['keywords'][i]['statusBar'] &&
        data['keywords'][i]['statusBar'] < 99
      ) {
        continue;
      }

      // url = data['keywords'][i]['url_analyse'].split(projectUrl)[1];

      this.suggestedUrls.push({
        url: url,
        keyword: data['keywords'][i]['keyword'],
        analysisID: data['keywords'][i]['analysisID'],
        url_analyse: data['keywords'][i]['url_analyse'],
      });
      this.suggestedUrlsFiltered.push({
        url: url,
        keyword: data['keywords'][i]['keyword'],
        analysisID: data['keywords'][i]['analysisID'],
        url_analyse: data['keywords'][i]['url_analyse'],
      });
    }
    this.suggestedUrls.push({ url: 'Add New Position' });
    this.suggestedUrlsFiltered.push({ url: 'Add New Position' });
  }
  getKeywords() {
    const getKeywordsSub = this.seoService
      .getKeywords({ project: this.selectedProject['domain'] })
      .subscribe({
        next: (response) => {
          this.constructKeywords(response);
        },
        error: (error) => {
          console.error(error);
        },
      });
    this.analysisSub.add(getKeywordsSub);
  }
  filterUrls(event: any) {
    this.suggestedUrlsFiltered = this.suggestedUrls.filter((url: any) =>
      url['url'].toLowerCase().includes(event.target.value.toLowerCase()) ||
      url['keyword'].toLowerCase().includes(event.target.value.toLowerCase())
        ? url
        : null,
    );
  }

  isObjectEmpty(objectName: any) {
    return JSON.stringify(objectName) === '{}';
  }

  constructRankings(data: any) {
    try {
      this.rankings = data?.rankings_table;
      this.tableHeaderTitles = data?.variables;
      this.domainOptions = [];

      for (let i = 0; i < this.rankings?.length; i++) {
        if (this.rankings[i].factors) {
          for (let key in this.rankings[i].factors) {
            if (this.rankings[i].factors.hasOwnProperty(key)) {
              this.rankings[i].factors[key] = parseFloat(
                this.rankings[i].factors[key],
              ).toFixed(2);
            }
          }
        }

        let tmpUrl = this.rankings[i]['url'].endsWith('/')
          ? this.rankings[i]['url']
              .replace('www.', '')
              .replace('http://', 'https://')
              .slice(0, -1)
          : this.rankings[i]['url']
              .replace('www.', '')
              .replace('http://', 'https://');
        let url_analyse = this.rankings[i]['url_analyse'].endsWith('/')
          ? this.rankings[i]['url_analyse']
              .replace('www.', '')
              .replace('http://', 'https://')
              .slice(0, -1)
          : this.rankings[i]['url_analyse']
              .replace('www.', '')
              .replace('http://', 'https');

        if (tmpUrl === url_analyse) {
          this.rankings[i]['ourDomain'] = true;
        } else {
          this.rankings[i]['ourDomain'] = false;
        }
        this.domainOptions.push(this.rankings[i]['domain']);
      }
      this.domainOptions.push('Show All');
    } catch (e) {
      console.log(e);
      this.rankings = [];
      this.tableHeaderTitles = [];
    }
  }

  getAnalysisProgress(data: any) {
    const getAnalysisProgressSub = this.seoService
      .analysesAnalyseInformation({
        analysisID: data['analysisID'],
      })
      .subscribe({
        next: (res) => {
          let steps = res['steps'];
          let stepsKeys = Object.keys(steps);

          this.showBarloaderv2 = true;
          for (let i = 0; i < this.socketLoaders.length; i++) {
            for (let j = 0; j < stepsKeys.length; j++) {
              if (this.socketLoaders[i].name === stepsKeys[j]) {
                this.socketLoaders[i].value = steps[stepsKeys[j]];
                this.socketLoaders[i].percentage = Math.round(
                  (steps[stepsKeys[j]] / this.socketLoaders[i].maxValue) * 100,
                );
              }
            }
          }
          if (res['statusBar'] >= 100) {
            this.barloaderv2_percentage = 100;
          } else {
            this.barloaderv2_percentage = res['statusBar'];
          }
          this.barloaderFuncv2();
        },
        error: (err) => {
          console.error(err);
        },
      });
    this.analysisSub.add(getAnalysisProgressSub);
  }
  showAnnotationBool = false;
  annotationPosition = {
    x: 0,
    y: '0px',
  };
  showCompetitorAnnotationBool = false;
  competitorAnnotationPosition = {
    x: 0,
    y: '0px',
  };
  clientAnnotationLastElement = false;
  competitorAnnotationLastElement = false;
  showAnnotationLineChart() {
    const annotationFunction = () => {
      try {
        let clientPosition = this.rankings.findIndex((r: any) => r.ourDomain);
        if (clientPosition == this.rankings.length - 1) {
          this.clientAnnotationLastElement = true;
        } else {
          this.clientAnnotationLastElement = false;
        }
        if (this.toogleCompetitor) {
          if (
            this.filters[0].value == 'overview_filter' &&
            this.filters[0].active
          ) {
            this.showCompetitorAnnotationBool = false;
            return;
          }

          this.showCompetitorAnnotationBool = true;
          rectElement = document.querySelectorAll(
            'google-chart svg g > g[clip-path] g:last-child rect',
          );

          let competitorPosition = this.rankings.findIndex(
            (r: any) => r.url === this.competitorURL,
          );

          let clientRectPosition = clientPosition > competitorPosition ? 1 : 0;
          let competitorRectPosition =
            clientPosition > competitorPosition ? 0 : 1;

          this.annotationPosition = {
            x: rectElement[clientRectPosition]?.getAttribute('x'),
            y:
              parseFloat(rectElement[clientRectPosition]?.getAttribute('y')) -
              10 +
              'px',
          };
          if (competitorPosition == this.rankings.length - 1) {
            this.competitorAnnotationLastElement = true;
          } else {
            this.competitorAnnotationLastElement = false;
          }
          this.competitorAnnotationPosition = {
            x: parseFloat(
              rectElement[competitorRectPosition]?.getAttribute('x'),
            ),
            y:
              parseFloat(
                rectElement[competitorRectPosition]?.getAttribute('y'),
              ) -
              10 +
              'px',
          };
        } else {
          this.showCompetitorAnnotationBool = false;
          rectElement = document.querySelector(
            'google-chart svg g > g[clip-path] g:last-child rect',
          );

          this.annotationPosition = {
            x: rectElement?.getAttribute('x'),
            y: parseFloat(rectElement?.getAttribute('y')) - 10 + 'px',
          };
        }
      } catch (e) {
        console.log(e);
      }
    };

    let rectElement: any;
    let tmpIntervalTries = 0;
    let interval = setInterval(() => {
      if (
        document.querySelector(
          'google-chart svg g > g[clip-path] g:last-child rect',
        ) ||
        tmpIntervalTries > 100
      ) {
        clearInterval(interval);
        annotationFunction();
      }
      tmpIntervalTries++;
    }, 10);
  }
  filterClicked(filter: any) {
    this.filters.filter((filter: any) => filter.active)[0].active = false;
    filter.active = true;
    this.updateCustomChart();
  }
  updateCustomChart(cardChangedSort: boolean = false) {
    // if (this.toogleCompetitor) {
    //   let competitorsUrls = this.rankings
    //     .filter((r: any) => r.domain !== this.selectedProject['domain'])
    //     .map((r: any) => r.url);

    //   if (this.competitorURL == '') {
    //     this.competitorURL = competitorsUrls[0];
    //   }

    //   this.selectedCompetitorData = this.competitorsData.filter(
    //     (c: any) => c.url_analyse === this.competitorURL
    //   )[0];

    //   this.barChartOutputData = {
    //     url: {
    //       client: this.basicInfos.value.landingPage.split(' - ')[0],
    //       competitor: this.competitorURL,
    //     },
    //     chartData: {
    //       clientData: this.mainObject,
    //       competitorData: this.selectedCompetitorData,
    //     },
    //     rankings: this.rankings,
    //     allCompetitors: this.competitorsData,
    //     descriptions: this.descriptions,
    //     competitors: competitorsUrls,
    //     comparable: true,
    //     units: this.units,
    //     comp_combined_values: this.comp_combined_values,
    //     correct_values: this.correct_values,
    //   };
    //   this.constuctRakingLineChartData();
    // } else {
    //   this.barChartOutputData = {
    //     url: {
    //       client: this.basicInfos.value.landingPage,
    //     },
    //     rankings: this.rankings,
    //     chartData: this.mainObject,
    //     descriptions: this.descriptions,
    //     correct_values: this.correct_values,
    //     comparable: false,
    //     units: this.units,
    //   };
    // }
    if (!this.keywordData) {
      return;
    }

    this.activeFilter = this.cardsData.filter(
      (filter: any) => filter.selected,
    )[0].name;

    const formattedData = Object.keys(this.keywordData?.variables)
      .filter(
        (key) =>
          key != 'labels' &&
          key != 'domain' &&
          key != 'date' &&
          key != 'category_summary',
      )
      .map((key) => ({
        variable: key,
        variables: Object.entries(this.keywordData.variables[key]).map(
          ([name, value]) => ({
            name,
            value,
            selected: false,
          }),
        ),
      }));

    this.barChartOutputData = {
      variable_labels: this.keywordData.variable_labels,
      yourScore:
        this.keywordData.technical_values_per_domain_for_range[
          this.keywordData.domain
        ],
      units: this.keywordData.units,
      correct_values: this.keywordData.correct_values,
      renamed_variables: this.keywordData.renamed_variables,
      rename_variables_positive: this.keywordData.rename_variables_positive,
      chartData: formattedData,
      date: this.keywordData.date,
      domain: this.keywordData.domain,
      labels: this.keywordData.variables.labels,
      category_summary: Object.keys(
        this.keywordData.variables.category_summary,
      ).map((key: any) => ({
        name: key,
        value: this.keywordData.variables.category_summary[key],
      })),
      activeFilter: this.activeFilter,
      selectedCompetitor: this.selectedObject?.domain || '',
      cardChangedSort: cardChangedSort,
      top_selected: this.keywordData.top_selected,
    };

    this.constructBarchartData();
  }

  onToggleChange(event: any, item: any, customStyles: any) {
    let domOption = event.target.closest('.custom_horizontal_option_select');
    customStyles.width = domOption.clientWidth + 'px';
    customStyles.transform = `translateX(${domOption.offsetLeft}px)`;

    for (let i = 0; i < this.horizontalSingleSelectOptions.length; i++) {
      this.horizontalSingleSelectOptions[i].selected = false;
    }

    item.selected = true;
    this.selectedFilterButton = item.value;

    if (!this.selectedObject) return;

    if (item.value == 'competitor') {
      this.isLoadingBacklinkTable = true;

      this.show_ai_score_column = false;
      const getAnalyseBacklinkSub = this.seoService
        .getAnalyseBacklinkValues(
          {
            // keyword: 'fathers day',
            project: this.selectedObject.domain,
            email: this.selectedProject['email'],
            lang: 'en',
            region: 'United States',
            variables: this.backLinkselectedVariable,
            page: this.pageIndex + 1,
            filterDomain: '',
            pageSize: this.pageSize,
          },
          this.sortByRelevancyScoreTrigger ? '1' : '0',
        )
        .subscribe({
          next: (res) => {
            this.isLoadingBacklinkTable = false;
            if (this.showInternalLinkOnlyTable) {
              this.internalLinkingDataTable = res['result'];
              this.internalTotalCount = res['total_count'];

              this.constructBacklinkTableData();
            } else {
              this.backlinkOnlyTableData = res['result'];
              this.backlinkTotalCount = res['total_count'];

              this.tableVarianleOne = res['result']?.[0]?.var1;
              this.tableVarianleTwo = res['result']?.[0]?.var2;

              try {
                if (
                  this.backlinkOnlyTableData[0]['AI_score'] != null &&
                  this.backlinkOnlyTableData[0]['AI_score'] != undefined
                ) {
                  this.show_ai_score_column = true;
                }
              } catch (e) {
                console.log(e);
              }

              this.constructBacklinkTableData();
            }

            this.dataSource.data.length = res['total_count'];
            this.dataSource.paginator = this.paginator;
          },
          error: (err) => {
            this.isLoadingBacklinkTable = false;
            console.error(err);
          },
        });

      this.analysisSub.add(getAnalyseBacklinkSub);
    } else {
      this.backlinkOnlyTableFunction();
    }
  }
  initializeHeadlines() {
    this.headlinesTexts = this.socketLoaders.map((loader, index) => ({
      text: loader.name,
      active: index === 0,
      hide: index !== 0,
    }));
  }

  updateStatusOfProject(value: number) {
    // this.seoService
    //   .getStatusOfProject({ domain: this.selectedProjectDomain })
    //   .subscribe({
    //     next: (res) => {
    //       if (res.progresses && res.progresses.length > 0) {
    //         if (res.averageStatusBar >= 100) {
    //           this.barloaderv2_percentage = 100;
    //         } else {
    //           this.barloaderv2_percentage = res.averageStatusBar;
    //         }
    //         if (res.averageStatusBar >= 100) {
    //           console.log(
    //             'considering project finished already so call keywords again, this error happens if status is finished but project not properly finalized, get-variables-summary not working... so it looks like a loop'
    //           );
    //           this.getKeywordsData();
    //           this.sidenavService.setSeoProject(this.selectedProject);
    //         }
    //       }
    //     },
    //     error: (err) => {
    //       console.error(err);
    //     },
    //   });
  }

  barchartClicked(event: any) {
    if (this.filters[0].value == 'overview_filter' && this.filters[0].active) {
      return;
    }

    this.clickedFactor = event.event?.name;
    this.showNameClickedFactor = event.event?.showName;

    this.backLinkselectedVariable = event.event?.name;

    if (
      this.selectedCard != 'Technical' &&
      this.barChartOutputData.chartData
        .filter((data: any) => data.variable == 'Technical')?.[0]
        ?.variables?.filter((data: any) => data.name == event.event?.name)
        .length == 0 &&
      this.barChartOutputData.chartData
        .filter((data: any) => data.variable == 'Backlink Profile')?.[0]
        ?.variables?.filter((data: any) => data.name == event.event?.name)
        .length == 0
    ) {
      if (
        this.barChartOutputData.chartData
          .filter((data: any) => data.variable == 'Internal Linking')[0]
          .variables.filter((data: any) => data.name == event.event?.name)
          .length == 0
      ) {
        this.showBacklinkOnlyTable = true;
        this.showInternalLinkOnlyTable = false;
        this.backlinkOnlyTableFunction();
      } else {
        if (
          this.backLinkselectedVariable == 'distance' ||
          this.backLinkselectedVariable == 'pr'
        ) {
          this.showInternalLinkOnlyTable = true;
          this.showBacklinkOnlyTable = false;
          this.backlinkOnlyTableFunction();
        } else {
          this.showInternalLinkOnlyTable = false;
          this.showBacklinkOnlyTable = false;
        }
      }
    } else {
      this.showBacklinkOnlyTable = false;
      this.showInternalLinkOnlyTable = false;
    }

    if (this.selectedCard == 'Backlink Relevance') {
      // || this.selectedCard == "All KPI's"
      this.backlinkRelevanceTableActive = true;
    } else {
      this.backlinkRelevanceTableActive = false;
    }

    if (this.showBacklinkOnlyTable && !this.stopScrollBehavior) {
      try {
        document
          .querySelector('.ai_analysis_overview_scroll')
          ?.scrollIntoView({ behavior: 'smooth' });
      } catch (e) {}
    } else {
      setTimeout(() => {
        this.stopScrollBehavior = false;
      }, 100);
    }

    this.isFirstExecution = false;
    this.pageIndex = 0;
  }
  viewMore(keyword: any) {
    this.previewAnalysis = true;
    this.rate = '-';
    this.listOfVariables = [];
    this.listOfKeywords = [];

    let data;

    if (this.selectedFilterButton === 'competitor') {
      if (!keyword.distance) {
        data = {
          url: keyword.url_analyse,
          domain: this.selectedObject.domain,
          analyzeKeyword: keyword.keyword,
        };
      } else {
        data = {
          url: 'https://' + this.selectedObject.domain + '/' + keyword.url,
          domain: this.selectedObject.domain,
        };
      }
    } else {
      if (!keyword.distance) {
        data = {
          url: keyword.url_analyse || keyword.var1_link,
          domain: this.selectedProjectDomain,
          analyzeKeyword: keyword.keyword || keyword.var1_text,
        };
      } else {
        data = {
          url: 'https://' + this.selectedProjectDomain + '/' + keyword.url,
          domain: this.selectedProjectDomain,
        };
      }
    }

    this.seoService.measureDraft(data).subscribe(
      (res) => {
        this.rate = res.AI_score;
        this.listOfKeywords = res.keywords_ranking_for.sort(
          (a: any, b: any) => a.rank - b.rank,
        );

        const variables_measurements = res.variables_measurements;
        const variables_values = res.variables_values;
        const ranked_variables = res.ranked_variables;
        const variable_ranges = res.all_ranges_dict[this.selectedProjectDomain];

        const measurementsWithRank = Object.keys(variables_measurements).map(
          (key) => {
            const rank = ranked_variables[key];
            return {
              key: key,
              rank: rank !== undefined ? rank : Infinity,
              value: variables_measurements[key],
              varNum: variables_values[key],
              range:
                variable_ranges && key in variable_ranges
                  ? variable_ranges[key]
                  : 0,
            };
          },
        );

        this.listOfCategories = res.all_categorized;
        this.renamed_variables = res.renamed_variables;
        this.rename_variables_positive = res.rename_variables_positive;

        measurementsWithRank.sort((a, b) => a.rank - b.rank);

        this.listOfVariables = measurementsWithRank.map((item) => ({
          key: item.key,
          value: item.value,
          varNum: item.varNum,
          range: item.range,
        }));

        this.measurementIsLoading = false;
      },
      (error) => {},
    );

    setTimeout(() => {
      document
        .querySelector('.example-container')
        ?.prepend(
          document.querySelector<any>('.ai_analysis_slidein_container_main'),
        );

      setTimeout(() => {
        this.animateSlideClass = true;
      }, 50);
    }, 50);
  }
  getCategoryPercentage(range: string): string | null {
    return range
      ? '/' +
          range
            .replaceAll(' ', '')
            .replace(
              /(\d+)-(\d+)/,
              (_, num1, num2) =>
                `${Number(num1).toLocaleString()}-${Number(
                  num2,
                ).toLocaleString()}`,
            )
      : null;
  }
  competitorUrlChanged(event: any) {
    this.competitorURL = event;
    this.updateCustomChart();
  }
  sortByRelevancyScoreTrigger: boolean = false;
  sortByRelevancyScore() {
    this.rankingImpactFilterActive = false;
    this.pageIndex = 0;
    this.sortByRelevancyScoreTrigger = !this.sortByRelevancyScoreTrigger;
    this.backlinkOnlyTableFunction();
  }
  sortByRankingImpactTrigger: boolean = false;
  rankingImpactFilterActive: boolean = false;
  sortByRankingImpact() {
    this.rankingImpactFilterActive = true;
    this.pageIndex = 0;
    this.sortByRankingImpactTrigger = !this.sortByRankingImpactTrigger;
    this.backlinkOnlyTableFunction();
  }

  formatValueString(value: any) {
    let cat;
    for (const category in this.listOfCategories) {
      if (this.listOfCategories[category].includes(value.key)) {
        cat = category;
      }
    }

    if (
      value.key.includes('_sim') ||
      value.key.includes('perc_') ||
      value.key.includes('per_')
    ) {
      return value.varNum.toFixed(0);
    } else {
      if (value.varNum === 0) {
        return value.varNum.toFixed(0);
      } else if (Math.abs(value.varNum) >= 1000000) {
        return Math.floor(value.varNum / 1000000) + 'M';
      } else if (Math.abs(value.varNum) >= 1000) {
        return Math.floor(value.varNum / 1000) + 'K';
      } else if (Math.abs(value.varNum) >= 10) {
        return value.varNum.toFixed(0);
      } else if (Math.abs(value.varNum) < 1) {
        return value.varNum.toFixed(2);
      } else if (value.varNum % 1 !== 0) {
        return value.varNum.toFixed(2);
      } else {
        return value.varNum.toFixed(0);
      }
    }
  }

  sortFunctionImpact() {
    this.rankingImpactDirection =
      this.rankingImpactDirection == '1' ? '-1' : '1';

    if (this.rankingImpactDirection == '1') {
      this.listOfVariables = this.listOfVariables.sort(
        (a: any, b: any) => b.value - a.value,
      );
    } else {
      this.listOfVariables = this.listOfVariables.sort(
        (a: any, b: any) => a.value - b.value,
      );
    }
  }

  closePreview(event: any) {
    if (!event.target.closest('.ai_analysis_slidein_container')) {
      this.animateSlideClass = false;
      setTimeout(() => {
        this.previewAnalysis = false;
      }, 300);
    }
  }

  sortByDistanceTrigger: boolean = false;
  sortByDistance() {
    this.pageIndex = 0;
    this.sortByDistanceTrigger = !this.sortByDistanceTrigger;
    this.backlinkOnlyTableFunction();
  }

  sortByPageRankTrigger: boolean = false;
  sortByPageRank() {
    this.pageIndex = 0;
    this.sortByPageRankTrigger = !this.sortByPageRankTrigger;
    this.backlinkOnlyTableFunction();
  }

  isPositive(value: any): boolean {
    return value >= 0;
  }

  isLoadingBacklinkTable: boolean = false;
  constructBacklinkTableData(redirectToIssue: boolean = false) {
    if (this.showInternalLinkOnlyTable) {
      for (let i = 0; i < this.internalLinkingDataTable.length; i++) {
        if (this.internalLinkingDataTable[i]['title']?.length > 120) {
          this.internalLinkingDataTable[i]['show_title'] =
            this.internalLinkingDataTable[i]['title']?.substring(0, 120);
        } else {
          this.internalLinkingDataTable[i]['show_title'] =
            this.internalLinkingDataTable[i]['title'];
        }

        if (
          !this.internalLinkingDataTable[i]['title'] ||
          this.internalLinkingDataTable[i]['title'] == ''
        ) {
          this.internalLinkingDataTable[i]['show_title'] =
            this.internalLinkingDataTable[i]['url']?.substring(0, 120);
          this.internalLinkingDataTable[i]['title'] =
            this.internalLinkingDataTable[i]['url']?.substring(0, 120);
        }
      }
    } else {
      for (let i = 0; i < this.backlinkOnlyTableData.length; i++) {
        this.backlinkOnlyTableData[i]['show_var1_text'] =
          this.backlinkOnlyTableData[i]['var1_text'].substring(0, 60);

        this.backlinkOnlyTableData[i]['show_var2_text'] =
          this.backlinkOnlyTableData[i]['var2_text'].substring(0, 60);

        this.backlinkOnlyTableData[i]['var2_linkfull'] =
          this.backlinkOnlyTableData[i].var2_link;
      }
    }

    if (redirectToIssue) this.redirectToIssue();
  }

  openAiEditor(draft: any) {
    if (window.innerWidth < 768) {
      this.openInfoDialog();
      return;
    }

    if (draft.url_analyse) {
      draft['url'] = draft.url_analyse;
    } else {
      let domain;
      if (this.selectedFilterButton == 'competitor') {
        domain = this.selectedObject.domain;
      } else {
        domain = this.selectedProjectDomain;
      }
      draft['url'] = draft.var1_link;
    }

    sessionStorage.setItem('save_tab_for_content_editor', this.activeTab);
    sessionStorage.setItem('openAiEditor_different_page', this.router?.url);
    sessionStorage.setItem('draft', JSON.stringify(draft));
    this.router.navigate(['/seo/content']);
  }

  searchBacklinkTableData() {
    this.pageIndex = 0;
    this.backlinkOnlyTableFunction();
  }
  backlinkOnlyTableFunction(redirectToIssue: boolean = false) {
    let tmpSearch = this.selectDomainOption;
    if (tmpSearch == 'Show All') {
      tmpSearch = '';
    }

    this.isLoadingBacklinkTable = true;

    let project = this.selectedProjectDomain;
    if (this.selectedFilterButton == 'competitor') {
      project = this.selectedObject.domain;
    }

    let sort: any;
    if (this.backLinkselectedVariable === 'distance') {
      sort = !this.sortByDistanceTrigger;
    } else if (this.backLinkselectedVariable === 'pr') {
      sort = this.sortByPageRankTrigger;
    } else {
      sort = this.sortByRelevancyScoreTrigger;
    }

    if (this.rankingImpactFilterActive) {
      sort = this.sortByRankingImpactTrigger;
    }

    this.show_ai_score_column = false;
    const getAnalyseBacklinkSub = this.seoService
      .getAnalyseBacklinkValues(
        {
          // keyword: 'fathers day',
          project: project,
          email: this.selectedProject['email'],
          lang: 'en',
          region: 'United States',
          variables: this.backLinkselectedVariable,
          page: this.pageIndex + 1,
          filterDomain: '',
          pageSize: this.pageSize,
          ...(this.rankingImpactFilterActive
            ? {
                sortKey: 'AI_score',
              }
            : {}),

          ...(this.selected_search_input != ''
            ? this.selected_search_option == 'Keyword'
              ? { keyword: this.selected_search_input }
              : { url: this.processUrl(this.selected_search_input) }
            : {}),

          ...(this.isViewAllActiveProject ? { view_all_projects: true } : {}),

          ...(this.uniqueProjects.length > 0
            ? { uniqueProjects: this.uniqueProjects }
            : {}),

          ...(this.selectedModelObj.value != 'view_all'
            ? { model: this.selectedModelObj.value }
            : {}),
        },
        // {
        //   url_analyse: this.selectedProjectURL,
        //   keyword: this.backLinkselectedVariable,
        //   project: this.selectedProjectDomain,
        //   email: this.selectedProject['email'],
        //   lang: this.selectedProject['lang'],
        //   region: this.selectedProject['region'],
        //   analysisID: 'ed8c0a4d-e2af-403d-9185-507a039bd90c',
        //   variables: this.backLinkselectedVariable,
        //   page: this.pageIndex + 1,
        //   filterDomain: tmpSearch,
        //   pageSize: this.pageSize,
        // },
        sort ? '1' : '0',
      )
      .subscribe({
        next: (res) => {
          this.isLoadingBacklinkTable = false;

          if (this.showInternalLinkOnlyTable) {
            this.internalLinkingDataTable = res['result'];

            try {
              if (this.rankingImpactFilterActive) {
                if (sort) {
                  this.internalLinkingDataTable =
                    this.internalLinkingDataTable.sort(
                      (a: any, b: any) => a['AI_score'] - b['AI_score'],
                    );
                } else {
                  this.internalLinkingDataTable =
                    this.internalLinkingDataTable.sort(
                      (a: any, b: any) => b['AI_score'] - a['AI_score'],
                    );
                }
              }
            } catch (e) {
              console.log(e);
            }

            this.internalTotalCount = res['total_count'];
            this.constructBacklinkTableData();
          } else {
            this.backlinkOnlyTableData = res['result'];
            this.backlinkTotalCount = res['total_count'];

            this.tableVarianleOne = res['result']?.[0]?.var1;
            this.tableVarianleTwo = res['result']?.[0]?.var2;

            try {
              if (this.rankingImpactFilterActive) {
                if (sort) {
                  this.backlinkOnlyTableData = this.backlinkOnlyTableData.sort(
                    (a: any, b: any) => a['AI_score'] - b['AI_score'],
                  );
                } else {
                  this.backlinkOnlyTableData = this.backlinkOnlyTableData.sort(
                    (a: any, b: any) => b['AI_score'] - a['AI_score'],
                  );
                }
              }
            } catch (e) {
              console.log(e);
            }

            try {
              if (
                this.backlinkOnlyTableData[0]['AI_score'] != null &&
                this.backlinkOnlyTableData[0]['AI_score'] != undefined
              ) {
                this.show_ai_score_column = true;
              }
            } catch (e) {
              console.log(e);
            }

            this.constructBacklinkTableData(redirectToIssue);
          }

          this.dataSource.data.length = res['total_count'];
          this.dataSource.paginator = this.paginator;
        },
        error: (err) => {
          this.isLoadingBacklinkTable = false;
          console.error(err);
        },
      });

    this.analysisSub.add(getAnalyseBacklinkSub);
  }
  formatPageRank(val: any) {
    return parseFloat(val).toFixed(3);
  }
  redirectToBacklinkUrl(url: string) {
    window.open(url, '_blank');
  }

  formatPercentage(val: any) {
    return (val * 100).toFixed(0);
  }
  showMoreClicked(item: any) {
    if (item['showMore'] == undefined) {
      item['showMore'] = false;
    }
    item['showMore'] = !item['showMore'];

    if (item['var1_link'] && item['var1_link'].length > 0) {
      window.navigator.clipboard.writeText(item['var1_link']);
    }
  }
  showMoreClicked2(item: any) {
    if (item['showMore2'] == undefined) {
      item['showMore2'] = false;
    }
    item['showMore2'] = !item['showMore2'];

    if (item['var2_link'] && item['var2_link'].length > 0) {
      window.navigator.clipboard.writeText(item['var2_link']);
    }
  }
  onPageChange(event: any) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.backlinkOnlyTableFunction();
  }
  onPageChange2(event: any) {
    this.paginator['_pageSize'] = event.value;
    this.onPageChange({ pageSize: event.value, pageIndex: this.pageIndex });
  }
  barloaderFuncv2(finished: boolean = false) {
    // reset all headlines - to be removed in production
    for (let i = 0; i < this.headlinesTexts.length; i++) {
      this.headlinesTexts[i].active = false;
      this.headlinesTexts[i].hide = false;
    }
    // reset all headlines - to be removed in production

    const setActiveHeadline = (index: number) => {
      for (let i = 0; i < this.headlinesTexts.length; i++) {
        if (this.headlinesTexts[index - 1]) {
          this.headlinesTexts[index - 1].hide = true;
        }
        if (i === index) {
          this.headlinesTexts[i].active = true;
        } else {
          this.headlinesTexts[i].active = false;
        }
      }
    };

    let socketLoadersValue = 0;
    let socketLoadersMaxValue = 0;
    for (let i = 0; i < this.socketLoaders.length; i++) {
      socketLoadersValue += this.socketLoaders[i].value;
      socketLoadersMaxValue += this.socketLoaders[i].maxValue;
    }
    if ((socketLoadersValue / socketLoadersMaxValue) * 100 >= 100) {
      this.barloaderv2_percentage = 100;
    } else {
      this.barloaderv2_percentage = Math.round(
        (socketLoadersValue / socketLoadersMaxValue) * 100,
      );
    }

    if (this.barloaderv2_percentage < 30) {
      setActiveHeadline(0);
    } else if (this.barloaderv2_percentage < 80) {
      setActiveHeadline(1);
    } else if (this.barloaderv2_percentage <= 90) {
      setActiveHeadline(2);
    } else if (this.barloaderv2_percentage <= 97) {
      setActiveHeadline(3);
    } else if (this.barloaderv2_percentage >= 100) {
      setActiveHeadline(4);
    }

    if (this.barloaderv2_percentage >= 100 || finished) {
      this.barloaderv2_percentage = 100;
      this.showBarloaderv2 = false;
      this.showPageContent = true;
      try {
        let index = this.horizontalOptions.findIndex(
          (item) => item.selected === true,
        );
        setTimeout(() => {
          try {
            document
              .querySelectorAll<HTMLElement>('.custom_horizontal_option_select')
              [index]?.click();
          } catch (e) {
            console.log(e);
          }
        }, 100);
      } catch (e) {
        console.log(e);
      }
    }
  }
  toogleAddCompetitor() {
    this.toogleCompetitor = !this.toogleCompetitor;
  }
  updateHorizontalOptions(event: any, item: any, customStyles: any) {
    try {
      if (!event.target.closest('.custom_horizontal_option_select')) return;
      if (this.horizontalOptions.find((f) => f.selected === true) === item)
        return;

      this.horizontalOptions.forEach((element) => {
        element.selected = false;
      });
      item.selected = true;

      if (item.value === 'competitor_comparison') {
        this.toogleCompetitor = true;
        for (let i = 0; i < this.filters.length; i++) {
          this.filters[i].active = false;
        }
        this.filters.unshift({
          text: 'Overview',
          value: 'overview_filter',
          active: true,
          data: () => {
            return {
              overview_filter: {
                onPageFactors: this.onPageFactors,
                technicalFactors: this.technicalFactors,
                backlinksFactors: this.backlinksFactors,
                relevancies: this.relevancies,
                backlink_relevancies: this.backlink_relevancies,
              },
            };
          },
        });

        this.mainObject = this.filters[0].data();
      } else {
        this.hideLineChartOnly = false;
        this.toogleCompetitor = false;

        if (
          this.filters[0].value == 'overview_filter' &&
          this.filters[0].active
        ) {
          this.filters[0].active = false;
          this.filters[1].active = true;
          this.mainObject = this.filters[1].data();
        }

        this.filters = this.filters.filter(
          (f: any) => f.value !== 'overview_filter',
        );
      }
      this.updateCustomChart();

      let domOption = event.target.closest('.custom_horizontal_option_select');
      customStyles.width = domOption.clientWidth + 'px';
      customStyles.transform = `translateX(${domOption.offsetLeft}px)`;
    } catch (e) {
      console.log(e);
    }
  }

  getRenamedVariables(variableName: string): void {
    const lang = this.localStorageService.get('language');
    if (lang == 'ja') {
      return (
        this.renamed_variables_2?.[variableName]?.name_japanese || variableName
      );
    } else if (lang == 'de') {
      return (
        this.renamed_variables_2?.[variableName]?.name_german || variableName
      );
    } else {
      return this.renamed_variables_2?.[variableName]?.name || variableName;
    }
  }

  constructBarchartData() {
    try {
      let list = [];

      try {
        for (let i = 0; i < this.barChartOutputData.chartData?.length; i++) {
          for (
            let j = 0;
            j < this.barChartOutputData.chartData[i].variables?.length;
            j++
          ) {
            if (this.barChartOutputData.chartData[i].variable != 'Technical') {
              list.push(this.barChartOutputData.chartData[i].variables[j]);
            } else {
              if (
                this.barChartOutputData.chartData[i].variables[j].name ==
                'performance_score'
              ) {
                list.push(this.barChartOutputData.chartData[i].variables[j]);
              } else if (
                this.barChartOutputData.chartData[i].variables[j].name ==
                'speedIndex'
              ) {
                list.push(this.barChartOutputData.chartData[i].variables[j]);
              } else if (
                this.barChartOutputData.chartData[i].variables[j].name ==
                'totalByteWeight'
              ) {
                list.push(this.barChartOutputData.chartData[i].variables[j]);
              } else if (
                this.barChartOutputData.chartData[i].variables[j].name ==
                'accessibility_score'
              ) {
                list.push(this.barChartOutputData.chartData[i].variables[j]);
              } else if (
                this.barChartOutputData.chartData[i].variables[j].name ==
                'best_practices_score'
              ) {
                list.push(this.barChartOutputData.chartData[i].variables[j]);
              } else if (
                this.barChartOutputData.chartData[i].variables[j].name ==
                'Time to Interactive'
              ) {
                list.push(this.barChartOutputData.chartData[i].variables[j]);
              } else if (
                this.barChartOutputData.chartData[i].variables[j].name ==
                'Largest Contentful Paint'
              ) {
                list.push(this.barChartOutputData.chartData[i].variables[j]);
              }
            }
          }
        }
      } catch (e) {
        console.log(e);
      }

      if (Object.keys(this.barChartOutputData).length === 0) {
        this.showCustomChart = false;
      } else {
        this.showCustomChart = true;
      }

      this.formatted_barchartInputData = list;

      for (let i = 0; i < this.formatted_barchartInputData?.length; i++) {
        this.formatted_barchartInputData[i]['tmp_category'] =
          this.findCategoryName(this.formatted_barchartInputData[i]['name']);
        this.formatted_barchartInputData[i]['random_issue'] =
          this.returnTagPill(this.formatted_barchartInputData[i]['name']);
        this.formatted_barchartInputData[i]['renamed_variable_2'] =
          this.getRenamedVariables(this.formatted_barchartInputData[i]['name']);
      }

      this.formatted_barchartInputData = this.formatted_barchartInputData.sort(
        (a: any, b: any) => {
          if (a['blurElement']) {
            return -1;
          } else if (b['blurElement']) {
            return 1;
          }
          return a.value - b.value;
        },
      );

      this.formatted_barchartInputData =
        this.formatted_barchartInputData.filter(
          (tmp: any) => tmp.tmp_category == 'Content Relevance',
        );

      this.all_formatted_barchartInputData = [
        ...this.formatted_barchartInputData,
      ];

      this.formatted_barchartInputData =
        this.formatted_barchartInputData.splice(0, 4);
    } catch (e) {
      console.log(e);
    }
  }
  returnTagPill(variable: any) {
    const variableScore =
      this.keywordDataInsights?.variables_scores_mean?.[0]?.[variable];

    if (variableScore) {
      try {
        const value = variableScore.value;
        const rangeVal_1 = parseFloat(variableScore.range?.split('-')?.[0]);
        // const rangeVal_2 = parseFloat(variableScore.range?.split('-')?.[1]);

        if (value < rangeVal_1) {
          return 'Content_mismatch';
        } else {
          return 'Keyword_Overused';
        }
      } catch (e) {
        console.log(e);
      }
    }
    return null;
  }
  findCategoryName(variable: any) {
    let category = '';
    for (let i = 0; i < this.barChartOutputData.chartData.length; i++) {
      for (
        let j = 0;
        j < this.barChartOutputData.chartData[i].variables.length;
        j++
      ) {
        if (
          this.barChartOutputData.chartData[i].variables[j].name == variable
        ) {
          category = this.barChartOutputData.chartData[i].variable;
          break;
        }
      }
    }
    return category;
  }
  redirectToIssue() {
    const saveObj = {
      tableVarianleOne: this.tableVarianleOne,
      tableVarianleTwo: this.tableVarianleTwo,
      show_ai_score_column: this.show_ai_score_column,
      backlinkRelevanceTableActive: this.backlinkRelevanceTableActive,
      issue: this.clickedIssue,
      backlinkOnlyTableData: this.backlinkOnlyTableData,
      selectedProjectDomain: this.selectedProjectDomain,
      selectedProject: this.selectedProject,
      backLinkselectedVariable: this.backLinkselectedVariable,
    };

    this.localStorageService.set('ai-analysis-issue', saveObj);
    this.router.navigate(['seo/ai-analysis/issue']);
  }
  redirectToIssue2(issue: any, mobileViewClick: boolean = false) {
    // if (mobileViewClick && window.innerWidth > 820) {
    //   return;
    // }

    let saveObj = {
      tableVarianleOne: this.tableVarianleOne,
      tableVarianleTwo: this.tableVarianleTwo,
      show_ai_score_column: this.show_ai_score_column,
      backlinkRelevanceTableActive: this.backlinkRelevanceTableActive,
      issue: issue,
      backlinkOnlyTableData: this.backlinkOnlyTableData,
      selectedProject: this.selectedProject,
      backLinkselectedVariable: this.backLinkselectedVariable,
    };

    this.localStorageService.set('ai-analysis-issue', saveObj);
    this.router.navigate(['seo/ai-analysis/issue']);
  }
  viewMoreIssuesClicked() {
    this.formatted_barchartInputDataPageIndex++;

    this.formatted_barchartInputData =
      this.all_formatted_barchartInputData.slice(
        0,
        this.formatted_barchartInputDataPageIndex *
          this.formatted_barchartInputData_items_per_page,
      );
  }

  openInfoDialog() {
    this.infoDialogRef = this.dialog.open(InfoModalComponent, {
      width: '430px',
      data: {
        header: 'notice',
        content: 'ai_editor_mobile_notice',
      },
    });
  }

  changeModel(model: any) {
    this.selectedModel = model;
    // this.selectedModelObj = this.models.find((m: any) => m.value == model);
    this.selectedModelObj = this.modelCardsData.find(
      (m: any) => m.value == model,
    );
    this.stopScrollBehavior = true;
    this.loadingProjeect = true;
    this.getKeywordsData();
  }

  createShareableToken() {
    this.seoService
      .createShareableToken({
        obj: {
          lang: this.selectedLanguage,
          domain: this.selectedProjectDomain,
        },
      })
      .subscribe({
        next: (res: any) => {
          // this.getTranslatedText('something_went_wrong', 'phrases').subscribe(
          // (translatedText) => {
          // this.snackBar.open(translatedText, 'x', {
          //   duration: 2000,
          // });
          //   }
          // );

          navigator.clipboard.writeText(
            `${window.location.origin}/share/ai-audit/${res.token}`,
          );
          this.notificationService.info('Shareable token copied!');
        },
        error: (error: any) => {
          this.notificationService.info('Something went wrong!');
        },
      });
  }
}
